import {
	DailyBusinessHour,
	normalCallbackTimes,
	TimeParts,
} from '../models/callback-on-callnote.model';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT, SERVER_TIME_ZONE } from '../constants/time-zone';

export function isDayInPast(date: Date): boolean {
	const dateOnly = new Date(date);
	dateOnly.setHours(0, 0, 0, 0);

	const nowDateOnly = new Date();
	nowDateOnly.setHours(0, 0, 0, 0);

	return dateOnly < nowDateOnly;
}

export function isBusinessHour(time: Date, dailyBusinessHour: DailyBusinessHour): boolean {
	const minTotal = dailyBusinessHour.startHour * 60 + dailyBusinessHour.startMinute;
	const maxTotal = dailyBusinessHour.endHour * 60 + dailyBusinessHour.endMinute;
	const timeTotal = time.getHours() * 60 + time.getMinutes();

	return timeTotal >= minTotal && timeTotal <= maxTotal;
}

export function getDateOfDateAndTime(date: Date, time: Date): Date {
	const combinedDateAndTime = new Date(date);
	combinedDateAndTime.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
	return combinedDateAndTime;
}

export function timeIsOutsideOfTimeRangeOrWeekendDay(
	date: Date,
	startTime: TimeParts,
	endTime: TimeParts,
): boolean {
	return checkTimeRangeIsOutside(date, startTime, endTime);
}

export function nextRoundedPossibleTime(): Date {
	const coefficient = 1000 * 60 * 5;
	const date = new Date();
	return new Date(Math.round(date.getTime() / coefficient) * coefficient + 5 * 60000);
}

export function timeIsOutsideOfTimeRange(
	date: Date,
	startTime: TimeParts,
	endTime: TimeParts,
): boolean {
	return checkTimeRangeIsOutside(date, startTime, endTime, true);
}

function checkTimeRangeIsOutside(
	date: Date,
	startTime: TimeParts,
	endTime: TimeParts,
	ignoreWeekendCheck = false,
): boolean {
	if (!ignoreWeekendCheck && date.getDay() % 6 === 0) {
		return true;
	}
	const jsDate = dayjs(date);
	const startJsDate = dayjs(date).hour(startTime.hour).minute(startTime.minute);
	const endJsDate = dayjs(date).hour(endTime.hour).minute(endTime.minute);
	return jsDate.isBefore(startJsDate) || jsDate.isAfter(endJsDate);
}

export function isTimeInPast(date: Date, time: Date): boolean {
	const now = new Date();
	const combinedDateAndTime = new Date(date);
	combinedDateAndTime.setHours(time.getHours(), time.getMinutes(), time.getSeconds());

	return combinedDateAndTime < now;
}

export function convertDateToISOString(date: dayjs.Dayjs) {
	return date.format(DATE_TIME_FORMAT);
}

export function convertToServerTimeZone(date: Date) {
	return dayjs(date).tz(SERVER_TIME_ZONE);
}
